(() => {
  const initCargoSurfStickyATC = (root = document) => {
    root.querySelectorAll('[data-cs-sticky-atc]').forEach((sticky) => {
      if (sticky.dataset.initialized === 'true') return;
      sticky.dataset.initialized = 'true';

      const productInfo = sticky.closest('product-info');
      if (!productInfo) return;

      const stickyButton = sticky.querySelector('[data-cs-sticky-button]');
      const stickyLabel = sticky.querySelector('[data-cs-sticky-button-label]');
      const stickyPrice = sticky.querySelector('[data-cs-sticky-price]');
      const stickyVariant = sticky.querySelector('[data-cs-sticky-variant]');

      const getMainSubmit = () =>
        productInfo.querySelector('product-form [type="submit"][name="add"]') ||
        productInfo.querySelector('product-form [type="submit"]');

      const getBuyButtons = () =>
        productInfo.querySelector('[id^="ProductSubmitButton-"]')?.closest('.product-form') ||
        productInfo.querySelector('product-form');

      const syncFromPage = () => {
        const mainSubmit = getMainSubmit();
        if (!mainSubmit) return;

        stickyButton.disabled = mainSubmit.disabled;

        const mainLabel =
          mainSubmit.querySelector('span')?.textContent?.trim() ||
          (mainSubmit.disabled ? 'Sold out' : 'Add to cart');

        stickyLabel.textContent = mainLabel;

        const priceNode = productInfo.querySelector('[id^="price-"] .price-item--sale') ||
          productInfo.querySelector('[id^="price-"] .price-item--regular');

        if (priceNode) stickyPrice.textContent = priceNode.textContent.trim();

        const checkedOptions = Array.from(
          productInfo.querySelectorAll('variant-selects input[type="radio"]:checked')
        )
          .map((input) => input.value)
          .filter(Boolean);

        if (checkedOptions.length) {
          stickyVariant.textContent = checkedOptions.join(' / ');
        } else {
          const selects = Array.from(productInfo.querySelectorAll('variant-selects select'))
            .map((select) => select.options[select.selectedIndex]?.textContent?.trim())
            .filter(Boolean);

          if (selects.length) stickyVariant.textContent = selects.join(' / ');
        }
      };

      const updateVisibility = () => {
        const purchaseArea = getBuyButtons();
        if (!purchaseArea) return;

        const rect = purchaseArea.getBoundingClientRect();
        const hasPassedPurchaseArea = rect.bottom < 0;

        sticky.classList.toggle('is-visible', hasPassedPurchaseArea);
        sticky.setAttribute('aria-hidden', String(!hasPassedPurchaseArea));
      };

      stickyButton.addEventListener('click', () => {
        const mainSubmit = getMainSubmit();
        if (!mainSubmit || mainSubmit.disabled) return;
        mainSubmit.click();
      });

      const variantChangeUnsubscriber =
        typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined'
          ? subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
              if (data?.sectionId && data.sectionId !== productInfo.dataset.section) return;

              window.requestAnimationFrame(() => {
                syncFromPage();

                if (data?.variant?.title && stickyVariant) {
                  stickyVariant.textContent =
                    data.variant.title === 'Default Title' ? '' : data.variant.title;
                }
              });
            })
          : null;

      window.addEventListener('scroll', updateVisibility, { passive: true });
      window.addEventListener('resize', updateVisibility, { passive: true });

      syncFromPage();
      updateVisibility();
    });
  };

  initCargoSurfStickyATC();

  document.addEventListener('shopify:section:load', (event) => {
    initCargoSurfStickyATC(event.target);
  });

  document.addEventListener('product-info:loaded', (event) => {
    initCargoSurfStickyATC(event.target);
  });
})();
